import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { requestGetSectionStyle } from "./getSectionStyle.request";
import { ISectionStyle } from "./getSectionStyle.types";

const useSectionStyle = (
  options?: QueryOptions<ISectionStyle, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["section-style"],
    queryFn: async () => await requestGetSectionStyle(),
    onError: toastServerError,
    ...options
  });

  return { sectionStyle: data, ...rest };
};

export default useSectionStyle;
